<template>
  <v-card
    :width="width"
    :height="height"
    @click="click"
  >
    <v-img
      class="white--text align-end"
      :src="poi.priority_video_preview.preview_url"
    >
      <v-card-title class="caption pa-1 black-shadow-text">
        {{ poi.geotags.map(e => e.name).join(', ')}}
      </v-card-title>
      <v-card-title v-text="poi.name" class="caption pa-1 black-shadow-text" />
    </v-img>

    <v-card-text class="pa-1 white-shadow-text">
        {{ poi.hashtags.map(e => `#${e.name}`).join(' ') }}
      </v-card-text>
    <slot />

    <slot
      name="actions"
      v-bind:activator="activator"
    />
  </v-card>
</template>

<script>
export default {
  props: ['poi', 'width', 'height'],
  name: 'PoiCard',
  data: () => ({
    activator: false,
    shadowTextClass: 'shadow-text',
  }),
  methods: {
    click() {
      this.activator = !this.activator;
      this.$emit('click');
    },
  },
};
</script>

<style lang="css" scoped>
 .black-shadow-text {
   text-shadow: 1px 1px 5px #03092A,1px -1px 5px #03092A,-1px 1px 5px #03092A,-1px -1px 5px #03092A;
 }
 .white-shadow-text {
   text-shadow: 1px 1px 5px #D5E8F5,1px -1px 5px #D5E8F5,-1px 1px 5px #D5E8F5,-1px -1px 5px #D5E8F5;
 }
</style>
